import FuseNavigation from "@fuse/core/FuseNavigation";
import clsx from "clsx";
import { memo, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectNavigation } from "app/store/fuse/navigationSlice";
import useThemeMediaQuery from "@fuse/hooks/useThemeMediaQuery";
import { navbarCloseMobile } from "app/store/fuse/navbarSlice";
import { selectUser } from "app/store/userSlice";

function Navigation(props) {
  const rawNavigation = useSelector(selectNavigation);
  const user = useSelector(selectUser);
  const { email } = user.data;

  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down("lg"));
  const dispatch = useDispatch();

  // --- Filter Navigation ---
  const navigation = useMemo(() => {
    // const targetId = "admin.userManagement";

    const filterItems = (items) =>
      items
        .map((item) => {
          // if (email !== "jeff-weigang@ergos.com" && item.id === targetId) {
          //   return null;
          // }

          if (item.children) {
            const filtered = filterItems(item.children);
            return filtered.length > 0 ? { ...item, children: filtered } : null;
          }

          return item;
        })
        .filter(Boolean);

    return filterItems(rawNavigation);
  }, [rawNavigation, email]);

  return useMemo(() => {
    function handleItemClick() {
      if (isMobile) {
        dispatch(navbarCloseMobile());
      }
    }

    return (
      <FuseNavigation
        className={clsx("navigation", props.className)}
        navigation={navigation}
        layout={props.layout}
        dense={props.dense}
        active={props.active}
        onItemClick={handleItemClick}
      />
    );
  }, [
    dispatch,
    isMobile,
    navigation,
    props.active,
    props.className,
    props.dense,
    props.layout,
  ]);
}

Navigation.defaultProps = {
  layout: "vertical",
};

export default memo(Navigation);
